import { connect } from 'react-redux';
import ExcelDialog from '../../../../components/tasks/excel/ExcelDialog';
import { downloadExcel, previewExcel, uploadExcel } from 'core/slices/excel';

export default connect(null, { downloadExcel, previewExcel, uploadExcel })(ExcelDialog);
